import { useEffect } from "react";
import type { CallState, PlatformComponentProps } from "@b2bportal/core-types";
import type { UseInitProducts } from "../FintechMarketplaceConfig";
import { useFintechMarketplaceInitProductOffers } from "../hooks";

interface FintechMarketplaceProductsFetcherProps
  extends PlatformComponentProps {
  fetchWhenCallState?: Set<CallState>;
  useInitProducts: UseInitProducts<string>;
}
export const FintechMarketplaceProductsFetcher: React.FC<
  FintechMarketplaceProductsFetcherProps
> = (props) => {
  const { children, fetchWhenCallState } = props;

  const [productOffers, fetchProductOffers] =
    useFintechMarketplaceInitProductOffers(props);

  useEffect(() => {
    const keysToFetch = new Set(
      Object.entries(productOffers)
        .filter(([, { state }]) =>
          fetchWhenCallState ? fetchWhenCallState.has(state) : true
        )
        .map(([key]) => key)
    );
    if (keysToFetch.size > 0) {
      fetchProductOffers(keysToFetch);
    }
  }, [fetchProductOffers, fetchWhenCallState, productOffers]);

  return <>{children}</>;
};
